<div class="app-pos-matchine">
  <div class="header-pos">
    <!-- <span class="text">POS Farm Run</span> -->
    <img
        alt="Logo"
        class="logo"
        src="./assets/logo/farm-run-logo-2x.png"

      />
  </div>
  <div class="matchine">
    <div class="non-matchine" *ngIf="isLoading === false">
      <span class="text">ยังไม่มีเครื่อง POS</span>
      <a *ngIf="isPos === false" class="btn btn-success w-100 mb-5 j-center" routerLink="/setting/pos-setting/pos-setting"
        >สร้างเครื่อง POS</a
      >
      <a *ngIf="isPos === false" class="btn btn-primary w-100 mb-5 j-center" routerLink="/dashboard">Dashboard</a>
      <a *ngIf="isPos === true" class="btn btn-danger w-100 mb-5 j-center" routerLink="/auth/login" onclick="logout()">กลับสู่หน้า Login</a>
    </div>

    <ng-container *ngIf="matchines">
      <div class="box-matchine" *ngIf="isLoading === true" [ngClass]="{ 'box-flex': matchines.length <= 4 }">
        <div *ngFor="let item of matchines; let i = index" class="card-matchine" (click)="onClick(item)">
          <p class="text">{{ item.name }}</p>
        </div>
      </div>
    </ng-container>

    <div class="go-dashboard">
      <span class="dashboard" routerLink="/dashboard">Go To Dashboard</span>
    </div>
  </div>
</div>
